module.exports = __webpack_public_path__ + "img/dbe608b.jpg";